<template>
    <div class="caption-box">
        <component class="caption-box__inner"
                   :style="boxStyle"
                   :is="this.link !== undefined ? 'NavLink' : 'div'"
                   :link="this.link !== undefined ? link : null">
            <ImageObject v-if="image" :image="image" class="caption-box__image" />
            <div v-if="caption"
                 :class="['caption-box__caption', 'caption-position__' + captionPosition]"
                 :style="{maxWidth: captionMaxWidth}">
                <template v-if="typeof caption === 'object' && caption != null">
                    <ImageObject :image="caption" class="caption-box__caption-image"/>
                </template>
                <component v-else :is="captionTag" class="caption-box__caption-text" v-html="caption"></component>
            </div>
        </component>
    </div>
</template>
<script>
    export default {
        name: 'CaptionBox',
        props: {
            image: Object,
            link: Object,
            caption: [String, Object],
            captionPosition: {
                type: String,
                default: 'bottom-left'
            },
            captionMaxWidth: {
                type: String,
                default: '85%'
            },
            captionTag: {
                type: String,
                default: 'h2'
            },
            ratio: Number
        },
        data: function () {
            return {
                showImg: false,
                showCaptionImg: false
            }
        },
      computed: {
        boxStyle() {
          return  this.ratio ? {
            paddingBottom: this.ratio + '%'
          } : ''
        }
      }
    }
</script>
<style lang="scss" scoped>

    .caption-box {
        &__inner {
            display: block;
            position: relative;
            background: url(../../assets/bayview-village-placeholder.png) no-repeat center center #F1F1F1;
            background-blend-mode: color-burn;
            width: 100%;
            height: 100%;
        }

        &__image {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center;
        }

        &__caption {
            position: absolute;
            left: 0;
            bottom: 10%;
            background: #FFFFFF;
            padding: 1.4rem;
            text-transform: uppercase;

            &.caption-position {
                &__top-left {
                    top: 10%;
                    bottom: unset;
                }

                &__top-right {
                    left: unset;
                    right: 0;
                    bottom: unset;
                    top: 10%;
                }

                &__bottom-right {
                    left: unset;
                    right: 0;
                }
            }
        }

        &__caption-text {
            margin: 0;
            padding: 0;
            color: #070707;
        }

        &__caption {
            @media (min-width: 992px) {
                padding: 1.6rem;
            }

            @media (min-width: 1200px) {
                padding: 1.8rem;
            }
        }

        &__caption-image {
            width: 100%;
        }
    }
</style>
